import { useEffect, useState } from "react";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import styles from "./appBar.module.css";
import {
  DropDownButton,
  DropDownMenu,
  DropDownMenuItem,
} from "../styledComponents/styledComponents";
import { useTranslation } from "react-i18next";

import { useLanguage } from '../../functions/setGetLanguage';
import { supportedLanguages } from "../../i18n";

const AppBar = () => {
  const { i18n } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  // second language implementation (ideally should be one)
  const { setLanguage } = useLanguage();


  useEffect(() => {
    const currentLang = i18n.language || "en";
    localStorage.setItem("i18nextLng", currentLang);
    setLanguage(`_${currentLang}`);
  }, [i18n.language, setLanguage]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (lang) => {
    setAnchorEl(null);
    if (lang && lang !== i18n.language) {
      i18n.changeLanguage(lang);
    }
  };

  return (
    <div className={styles.appBarContainer}>
      <DropDownButton
        sx={{ position: "absolute", top: "20px", right: "20px" }}
        onClick={handleClick}
        endIcon={open ? <ExpandLessIcon /> : <ExpandMoreIcon />}
      >
        {supportedLanguages[i18n.language] || i18n.language}
      </DropDownButton>
      <DropDownMenu
        anchorEl={anchorEl}
        open={open}
        onClose={() => handleClose()}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        disableScrollLock={true}
        keepMounted
        marginThreshold={0}
      >
        {Object.entries(supportedLanguages).map(([code, label]) => (
          <DropDownMenuItem key={code} onClick={() => handleClose(code)}>
            {label}
          </DropDownMenuItem>
        ))}
      </DropDownMenu>
    </div>
  );
};

export default AppBar;
